import wrapError from "@/components/helpers/wrapError"

export const apiToggleTaskStatus = (params, success, error) => {
  $.ajax({
    type: "PUT",
    url: "/api/task",
    dataType: "json",
    processData: false,
    contentType: "application/json; charset=utf-8",
    data: JSON.stringify(params),
    success,
    error: wrapError(error, "apiToggleTaskStatus"),
  })
}
